<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-toolbar>
        <v-icon>ballot</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Campaña SMS Marketing</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" dense>
          <v-col>
            <v-file-input
              v-model="archivosASubir"
              dense
              placeholder="Seleccione el Archivo a Procesar"
              label="Subir Archivo Base"
              @change="recordsPreProceso = []"
              counter
              show-size
              prepend-icon="mdi-paperclip">
            </v-file-input>
          </v-col>
          <v-col cols="2"> </v-col>

          <v-col cols="4" lg="2" v-if="archivosASubir">
            <v-btn
              :disabled="loading"
              text
              class="black--text green"
              @click.native="ProcesarArchivo"
              small>
              Procesar &nbsp;
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="20"></v-progress-circular>
            </v-btn>

            <!-- <v-btn text dark class="green" @click="wea"  >
                               Try
                            </v-btn> -->
          </v-col>
        </v-row>
        <v-autocomplete
          :items="listTiposOferta"
          v-model="filtro.tipoOferta"
          item-text="descripcion"
          item-value="id"
          label="Tipo de Oferta"></v-autocomplete>

        <v-col cols="2">
          <!-- <v-select
            :items="diasSemana"
            v-model=""
            item-text="descripcion"
            item-value="id"
            label="Tipo de Oferta"
            placeholder="Seleccione uno"
            :menu-props="{ minWidth: '400' }"></v-select> -->
          <!-- <app-selector-periodos v-on:update-periodo="filtro.periodo = $event"></app-selector-periodos> -->
        </v-col>
        <v-row> </v-row>
      </v-card-text>
    </v-card>

    <v-card-actions>
      <v-btn dark color="blue" @click="procesarComercios">
        Generar Archivo Comercios&nbsp;
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn dark color="blue" @click="procesarComercializadores">
        Generar Archivo Comercializadores&nbsp;
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn dark color="blue" @click="procesarSucursales">
        Generar Archivo Sucursales&nbsp;
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn dark color="blue" @click="procesarONLINE">
        Generar Archivo ONLINE&nbsp;
        <v-icon>cloud_download</v-icon>
      </v-btn>
    </v-card-actions>

    <v-card-text v-if="records != 0">
      Se han procesado {{ records }} registros.
    </v-card-text>

    <!-- process progress -->

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{}}
      <p></p>
    </template>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
//import { Decimal } from "decimal.js";

import { http } from "@/axios";
//import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      // totalRegistros: 0,
      listTiposOferta: [],
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      records: [], // registros
      recordsProceso: [],
      recordsPreProceso: [],
      recordsAProcesar: [],
      recordsLotesCardCred: [],
      recordsLog: [],
      totalItemsLog: 0,
      totalItemsLotesCardCred: 0,
      optionsLog: {
        // definición de paginación
        sortDesc: [true],
        sortBy: ["lote"],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      archivosASubir: null,
      filtro: {
        tipoOferta: 0,
      },
    };
  },
  async created() {
    this.listTiposOferta.push({ id: 0, descripcion: "Cualquiera" });
    this.listTiposOferta.push({ id: 1, descripcion: "Renova" });
    this.listTiposOferta.push({ id: 2, descripcion: "Paralelos" });
    this.listTiposOferta.push({ id: 3, descripcion: "Inactivos" });
    this.listTiposOferta.push({ id: 4, descripcion: "Fugados" });
  },

  watch: {},

  computed: {
    ...mapGetters([
      "getActionFromLink",
      "error",
      "user",
      "ParametrosGenerales",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    async procesarComercios() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/baseSMSmarketingComercio",
            JSON.stringify({ tipoOferta: this.filtro.tipoOferta })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "BaseSMSmarketingComercio.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarComercializadores() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/baseSMSmarketingComercializadores",
            JSON.stringify({ tipoOferta: this.filtro.tipoOferta })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "BaseSMSmarketingComercializadores.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarSucursales() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/baseSMSmarketingSucursal",
            JSON.stringify({ tipoOferta: this.filtro.tipoOferta })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "BaseSMSmarketingSucursal.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarONLINE() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/baseSMSmarketingONLINE",
            JSON.stringify({ tipoOferta: this.filtro.tipoOferta })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;

              // switch (this.parametros.tipoOferta) {
              //   case 0:
              //     self.downloadFile(resp, "BaseSMSmarketingONLINE_Todos.csv");
              //     break;
              //   case 1:
              //     self.downloadFile(resp, "BaseSMSmarketingONLINE_Renova.csv");
              //     break;
              //   case 2:
              //     self.downloadFile(
              //       resp,
              //       "BaseSMSmarketingONLINE_Paralelo.csv"
              //     );
              //     break;
              //   case 3:
              //     self.downloadFile(
              //       resp,
              //       "BaseSMSmarketingONLINE_Inactivo.csv"
              //     );
              //     break;
              //   case 4:
              //     self.downloadFile(resp, "BaseSMSmarketingONLINE_Fugado.csv");
              //     break;
              // }

              self.downloadFile(resp, "BaseSMSmarketingONLINE.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    async imprimirRespaldatorio(item) {
      let params = [];
      params.push({
        Version: this.$store.state.version, // version
        LoteProcesoId: item.id,
        ImputacionPendiente: false,
      });
    },

    async ProcesarArchivo() {
      var mensaje = "";
      var self = this;

      if (mensaje != "") {
        const res = await this.$dialog.confirm({
          text: mensaje + "?",
          title: "Proceso de subida de archivo Base SMS Marketing",
          persistent: true,
        });

        if (!res) return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append("excelFile", this.archivosASubir);

      try {
        await http
          .post("/gestion/CampaniaSMSmarketing", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              this.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "CampaniaSMSmarketing.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
  },
};
</script>
